import React from "react";
const Footer = () => {
  return (
    <div className="container mt-10 pt-10 font-['Inter']">
      <div className="mx-auto">
        <div className="grid grid-cols-4 pb-8">
          <div className="col-span-4 flex items-center">
            <img
              className="my-5 h-[60px] w-[200px] "
              src="/images/Logo/logo.svg"
              alt="logo"
            />
          </div>
          <div className="col-span-4 pb-6 md:col-span-2">
            <div className="flex max-w-[460px] flex-col ">
              <h3 className="pb-6 text-base font-semibold">
                Book a free consultation
              </h3>
              <div className="flex flex-row gap-x-3 pb-6">
                <a href="https://calendly.com/info-dm0/explore-the-future-aipeakflow" target="_blank" rel="noopener noreferrer">
                  <input
                    type="button"
                    className="btn blue-btn  border-btn"
                    value="Book Now"
                  />
                </a>
              </div>
              <p className="text-xs font-normal text-[#4D5761]">
               Elevate your enterprise to new heights by harnessing the transformative power of AI, crafted and managed by our team of industry-leading specialists.
              </p>
            </div>
          </div>
          <div className="col-span-4 flex flex-row gap-x-8 md:col-span-2">
            <div className="flex md:w-1/2 ">
              <div className="flex flex-col ">
                <div className="my-2 font-semibold">Address</div>
                <div className="font-normal text-[#6B7280]">Nürnberg, Germany</div>
              </div>
            </div>
            <div className="md:w-1/2">
              <p className="my-2 font-semibold">Contact</p>
              <p className="font-normal text-[#6B7280]">
                Email:info@aipeakflow.com
              </p>
            </div>
          </div>
        </div>
        <hr className="col-span-2"></hr>
        <div className="grid grid-cols-2 items-center justify-between gap-y-3 py-8 text-sm">
          <div className="col-span-2 text-[#4D5761] md:col-span-1">
            ©AIPeakFlow
          </div>
          <div className="col-span-2 flex flex-row justify-end gap-x-6 text-main-color md:col-span-1">
            <div>Privacy Policy</div>
            <div>Terms of Service</div>
            <div>Cookie Settings</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
